module.exports = __webpack_public_path__ + "images/neutral-outline0281d1a319ab46cc4afcd51503a5b663.svg";